exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ui.middle.aligned.center.aligned.grid[data-v-48883a12] {\n  height: 100vh;\n  width: 100%;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.fade-enter-active[data-v-48883a12], .fade-leave-active[data-v-48883a12] {\n  -webkit-transition: opacity .5s;\n  transition: opacity .5s;\n}\n.fade-enter[data-v-48883a12], .fade-leave-to[data-v-48883a12] {\n  opacity: 0;\n}\n.ui.middle.aligned.center.aligned.grid > .column[data-v-48883a12] {\n  width: 450px;\n}\n@media screen and (max-width: 768px) {\n.ui.middle.aligned.center.aligned.grid > .column[data-v-48883a12] {\n      width: 100%;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-48883a12","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/auth/ExternalRegistration.vue
// module id = 587W
// module chunks = 1